(function () {
  function startCountdown() {
    const timerEl = document.querySelector('.aao-countdown-timer');
    const timerUnits = document.querySelectorAll('.aao-countdown-timer .aao-countdown-timer-unit');

    if (!timerEl || !timerUnits.length) return;

    const hoursEl = timerUnits[0].querySelector('.aao-countdown-timer-value');
    const minutesEl = timerUnits[1].querySelector('.aao-countdown-timer-value');
    const secondsEl = timerUnits[2].querySelector('.aao-countdown-timer-value');

    timerUnits2 = document.querySelectorAll('.apo-countdown-timer .apo-countdown-timer-unit');
    console.log("timerUnit2", timerUnits2);

    if (!timerUnits2) return;
    const hoursE2 = timerUnits2[0]?.querySelector('.apo-countdown-timer-value');
    const minutesE2 = timerUnits2[1]?.querySelector('.apo-countdown-timer-value');
    const secondsE2 = timerUnits2[2]?.querySelector('.apo-countdown-timer-value');

    if (!hoursEl || !minutesEl || !secondsEl) return;

    const DURATION = parseInt(timerEl.dataset.duration) || 19800;
    const storageKey = 'aao_countdown_end';

    // If key exists but time has already passed, remove it so it resets
    const existing = localStorage.getItem(storageKey);
    if (existing && parseInt(existing) <= Date.now()) {
      localStorage.removeItem(storageKey);
    }

    if (!localStorage.getItem(storageKey)) {
      localStorage.setItem(storageKey, Date.now() + DURATION * 1000);
    }

    const endTime = parseInt(localStorage.getItem(storageKey));

    function tick() {
      const remaining = Math.floor((endTime - Date.now()) / 1000);

      if (remaining <= 0) {
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';

        if (hoursE2 && minutesE2 && secondsE2) {
          hoursE2.textContent = '00';
          minutesE2.textContent = '00';
          secondsE2.textContent = '00';
        }

        // Clear storage so next page load starts a fresh countdown
        localStorage.removeItem(storageKey);
        clearInterval(interval);
        return;
      }

      const h = Math.floor(remaining / 3600);
      const m = Math.floor((remaining % 3600) / 60);
      const s = remaining % 60;

      hoursEl.textContent = String(h).padStart(2, '0');
      minutesEl.textContent = String(m).padStart(2, '0');
      secondsEl.textContent = String(s).padStart(2, '0');

      if (hoursE2 && minutesE2 && secondsE2) {
        hoursE2.textContent = String(h).padStart(2, '0');
        hoursE2.textContent = String(h).padStart(2, '0');
        minutesE2.textContent = String(m).padStart(2, '0');
        secondsE2.textContent = String(s).padStart(2, '0');
      }
    }

    tick();
    const interval = setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startCountdown);
  } else {
    startCountdown();
  }
})();